//THUNKS

import axios from "axios";
import {addUser, getBatabotAccess, getUser, setStatusUser} from "./batabot.actions";
import {addUserService, getUserService} from "../../services/user.service";
import {getBatabotAccessService} from "../../services/survey.service";

export const getBatabotAccessThunk = () => {
    return async (dispatch) => {
        try {
            const data = await getBatabotAccessService();
            console.log("batabot ACCESS", data);
            if (!data.error) dispatch(getBatabotAccess(data));
        } catch (error) {
            console.error(error);
        }
    };
};